import React, { useState, useEffect } from "react";
import IconFont from "./IconFont";

interface PasswordInputProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onPaste?: (event: React.ClipboardEvent<HTMLInputElement>) => void;
  readOnly?: boolean;
  inputClasses?: string;
  name?: string;
  id?: string;
  placeholder?: string;
  required?: boolean;
  showPasswordFromParent?: (setShow: React.Dispatch<React.SetStateAction<boolean>>) => void; // Updated type
}

/**
 * Password input component with show/hide functionality.
 *
 * @param value password value
 * @param name name of the input element
 * @param id id of the input element
 * @param required whether the input is required
 * @param onChange onChange function for the password input element
 * @param onPaste onPaste function
 * @param readOnly toggles the readOnly state
 * @param inputClasses additional classes for the input element
 * @param showPasswordFromParent function to control password visibility from parent
 */

const PasswordInput: React.FC<PasswordInputProps> = ({ value, onChange, readOnly = false, inputClasses = "", name = "password", id = "new-password", placeholder = "••••••••", onPaste = () => { }, required = true, showPasswordFromParent = () => { } }) => {
  const [showPassword, setShowPassword] = useState(false)

  // Handler to toggle password visibility
  const handleShowPassword = () => {
    setShowPassword(prev => !prev);
  };

  useEffect(() => {
    showPasswordFromParent(setShowPassword)
  }, [showPasswordFromParent])

  return (
    <div className="relative password-wrapper w-full">
      <input type={showPassword ? "text" : "password"} className={`control-base pr-[40px] ${inputClasses}`.trim()} name={name} id={id} placeholder={placeholder} onChange={(evt: React.ChangeEvent<HTMLInputElement>) => onChange(evt)} onPaste={onPaste} aria-describedby="password-constraints" autoComplete="new-password" required={required} value={value} readOnly={readOnly} />
      <button type="button" onClick={handleShowPassword} className="absolute right-[8px] top-1/2 m-0 h-6 w-6 -translate-y-1/2 border-none bg-transparent p-0 leading-[1] shadow-none" aria-label="Show password as plain text.">
        {showPassword ? <IconFont name="eye-off" size={16} /> : <IconFont name="eye" size={16} />}
      </button>
    </div>
  )
}

export default PasswordInput;
